import React from 'react';
import styled, { css } from 'styled-components';
import { forDesktop } from '@westwing/ui-kit/breakPoints';
import { FooterValueProps } from 'Client/components/OneFooter/index';
import { Align } from 'Client/components/Generic/ValueProps';

const Wrapper = styled.div`
    display: none;
    background: ${({ theme }) => theme.colors.turquoise10};
    border-bottom: 5px solid ${({ theme }) => theme.colors.turquoise100};
    margin-top: 40px;

    ${forDesktop`${css`
        display: block;
    `}`}
`;

const CartFooter = () => {
    return (
        <Wrapper>
            <FooterValueProps align={Align.center} />
        </Wrapper>
    );
};

export default CartFooter;
